// List of countries with name, code, and flag icon URL (using flagcdn.com)
// You can expand this list as needed
const countries = [
  { name: 'Kuwait', code: 'KW', flagUrl: 'https://flagcdn.com/kw.svg' },
  { name: 'United States', code: 'US', flagUrl: 'https://flagcdn.com/us.svg' },
  { name: 'United Kingdom', code: 'GB', flagUrl: 'https://flagcdn.com/gb.svg' },
  { name: 'India', code: 'IN', flagUrl: 'https://flagcdn.com/in.svg' },
  { name: 'Saudi Arabia', code: 'SA', flagUrl: 'https://flagcdn.com/sa.svg' },
  { name: 'United Arab Emirates', code: 'AE', flagUrl: 'https://flagcdn.com/ae.svg' },
  { name: 'Qatar', code: 'QA', flagUrl: 'https://flagcdn.com/qa.svg' },
  { name: 'Egypt', code: 'EG', flagUrl: 'https://flagcdn.com/eg.svg' },
  { name: 'Turkey', code: 'TR', flagUrl: 'https://flagcdn.com/tr.svg' },
  { name: 'Germany', code: 'DE', flagUrl: 'https://flagcdn.com/de.svg' },
  { name: 'France', code: 'FR', flagUrl: 'https://flagcdn.com/fr.svg' },
  { name: 'Italy', code: 'IT', flagUrl: 'https://flagcdn.com/it.svg' },
  { name: 'China', code: 'CN', flagUrl: 'https://flagcdn.com/cn.svg' },
  { name: 'Japan', code: 'JP', flagUrl: 'https://flagcdn.com/jp.svg' },
  { name: 'South Korea', code: 'KR', flagUrl: 'https://flagcdn.com/kr.svg' },
  { name: 'Australia', code: 'AU', flagUrl: 'https://flagcdn.com/au.svg' },
  { name: 'Canada', code: 'CA', flagUrl: 'https://flagcdn.com/ca.svg' },
  { name: 'Brazil', code: 'BR', flagUrl: 'https://flagcdn.com/br.svg' },
  { name: 'Russia', code: 'RU', flagUrl: 'https://flagcdn.com/ru.svg' },
  // ... add more as needed
];

export default countries; 